import { graphql } from 'react-relay';

export const pageHeaderFragment = graphql`
    fragment PageHeader_pageHeader on PageHeader {
        pageImageUrl
        pageBackgroundImageUrl
        smallHeader
        pageImageOverlayText
        authLink {
            ...AuthButton_authLink
        }
    }
`;

export const pageHeaderSiteInfoFragment = graphql`
    fragment PageHeader_siteInfo on SiteInfo {
        fundsListUrl
        rootUrl
        navigation {
            ...SimpleLink_simpleLink
        }
        searchPageUrl
    }
`;

export const pageHeaderTranslationsFragment = graphql`
    fragment PageHeader_translations on Translation @relay( plural: true ) {
        language
        url
    }
`;
